import type {
  RuntimeAdapter,
  AgentExecutionRequest,
  AgentExecutionEvent,
  ProviderHealth,
} from '../core/contracts/index.js';

export class MockSimulatorRuntime implements RuntimeAdapter {
  public runtimeId = 'mock-simulator-runtime';
  public runtimeVersion = '1.0.0';
  public supportedProtocols = [{ id: 'sim', version: '1.0' }];

  async *execute(request: AgentExecutionRequest): AsyncIterable<AgentExecutionEvent> {
    yield {
      executionId: request.executionId,
      taskId: request.taskId,
      type: 'progress',
      delta: 'Simulator initializing task execution...',
      timestamp: Date.now(),
    };

    if (request.grantedCapabilities.includes('publish_social_post') || request.grantedCapabilities.includes('send_external_message')) {
      yield {
        executionId: request.executionId,
        taskId: request.taskId,
        type: 'approval_required',
        approvalDetails: {
          capability: request.grantedCapabilities.find((c) => c === 'publish_social_post' || c === 'send_external_message')!,
          description: 'High-risk external action requires human confirmation.',
        },
        timestamp: Date.now() + 20,
      };
    }

    yield {
      executionId: request.executionId,
      taskId: request.taskId,
      type: 'result',
      result: `[Simulator Agent Response] Solved prompt: "${request.approvedPrompt}" using ${request.resolvedContext.citations.length} sources.`,
      timestamp: Date.now() + 40,
    };
  }

  async cancel(taskId: string): Promise<void> {
    console.log(`[MockSimulatorRuntime] Task ${taskId} cancelled.`);
  }

  async health(): Promise<ProviderHealth> {
    return {
      status: 'healthy',
      providerId: this.runtimeId,
      version: this.runtimeVersion,
      lastCheckedAt: Date.now(),
    };
  }
}
